import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import Swal from "sweetalert2";
import { Select } from "antd";
import PropertyesList from "../../../containers_Agent/Propertys_Agent/PropertyesList";
import {
  DynamicArticle,
  DynamicArticle_FirstPart,
} from "../../../components/HOC/DynamicArticle";
class ViewAllRent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      introduction: 0,
      firstname: "",
      secondname: "",
      duedate: "",
      paymentmonth: "",
      fee: 0,
      startdate: "",
      enddate: "",
      feelate: 0,
      save: null,
      rental: "",
      perpose: "",
      safly: 0,
      phone2: "",
      phone1: 0,
      forRE: 0,
      currency: "",
      Place_ku: "",
      NOoFProperty: "",
      Property: "",
      Area: "",
      Monthintroduction: 0,
      MonthForRent: 0,
      note: "",
      block: "",
      flour: "",
      metrPrice: "",
      update_close: false,
      update_open: false,
      Place_en: "",
      Place_ar: "",
      witness1: "",
      witness2: "",
      status: "active",
      createdAt: "",
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rent_all_view_obj !== this.props.rent_all_view_obj) {
      this.setState({
        introduction:
          this.props.rent_all_view_obj !== null &&
          this.props.rent_all_view_obj !== undefined
            ? parseFloat(
                this.props.rent_all_view_obj.introduction
                  .toString()
                  .replace(/,/g, "")
              )
            : 0,
        firstname: this.props.rent_all_view_obj.firstname,
        secondname: this.props.rent_all_view_obj.tenantId
          ? this.props.rent_all_view_obj.tenantId.secondname
          : "",
        duedate: this.props.rent_all_view_obj.duedate,
        paymentmonth: this.props.rent_all_view_obj.paymentmonth,
        fee: this.props.rent_all_view_obj.fee,
        startdate: this.props.rent_all_view_obj.startdate,
        enddate: this.props.rent_all_view_obj.enddate,
        feelate: this.props.rent_all_view_obj.feelate,
        rental: this.props.rent_all_view_obj.rental,
        perpose: this.props.rent_all_view_obj.perpose,
        safly: this.props.rent_all_view_obj.safly,
        phone2: this.props.rent_all_view_obj.tenantId
          ? this.props.rent_all_view_obj.tenantId.phone2
          : "",
        phone1: this.props.rent_all_view_obj.phone1,
        forRE: this.props.rent_all_view_obj.forRE,
        currency: this.props.rent_all_view_obj.currency,
        Place_ku: this.props.rent_all_view_obj.available_id
          ? this.props.rent_all_view_obj.available_id.Place_ku
          : "",
        Place_ar: this.props.rent_all_view_obj.available_id
          ? this.props.rent_all_view_obj.available_id.Place_ar
          : "",
        Place_en: this.props.rent_all_view_obj.available_id
          ? this.props.rent_all_view_obj.available_id.Place_en
          : "",
        NOoFProperty: this.props.rent_all_view_obj.available_id
          ? this.props.rent_all_view_obj.available_id.NOoFProperty
          : "",
        Property: this.props.rent_all_view_obj.available_id
          ? this.props.rent_all_view_obj.available_id.Property
          : "",
        Area: this.props.rent_all_view_obj.available_id
          ? this.props.rent_all_view_obj.available_id.Area
          : "",
        Monthintroduction: this.props.rent_all_view_obj.Monthintroduction,
        MonthForRent: this.props.rent_all_view_obj.MonthForRent,
        note: this.props.rent_all_view_obj.note,
        block: this.props.rent_all_view_obj.block,
        flour: this.props.rent_all_view_obj.flour,
        metrPrice: this.props.rent_all_view_obj.metrPrice,
        update_close: true,
        witness1: this.props.rent_all_view_obj.witness1,
        witness2: this.props.rent_all_view_obj.witness2,
        status: this.props.rent_all_view_obj.status,
        createdAt: this.props.rent_all_view_obj.createdAt,
      });
    }
  }

  Rent_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  onOpenUpdate = async () => {
    this.setState({ update_open: true, update_close: false });
  };
  onCloseUpdate = () => {
    const {
      change_Lang,
      rent_all_view_obj,
      Get_List_All_Rent_Contracts,
      onClose,
      Update_RentContract,
    } = this.props;
    const data = {
      firstname: this.state.firstname,
      secondname: this.state.secondname,
      introduction: parseFloat(
        this.state.introduction.toString().replace(/,/g, "")
      ),
      duedate: this.state.duedate ? this.state.duedate : this.state.startdate,
      perpose: this.state.perpose,
      fee: parseFloat(this.state.fee.toString().replace(/,/g, "")),
      feelate: parseFloat(this.state.feelate.toString().replace(/,/g, "")),
      rental: this.state.rental,
      paymentmonth: parseFloat(
        this.state.paymentmonth.toString().replace(/,/g, "")
      ),
      safly: parseFloat(this.state.safly.toString().replace(/,/g, "")),
      startdate: this.state.startdate,
      enddate: this.state.enddate,
      currency: this.props.EveryTimeTo_English(this.state.currency),
      phone2: this.state.phone2 !== "" ? this.state.phone2 : 0,
      phone1: this.state.phone1 !== "" ? this.state.phone1 : 0,
      Place_ku: this.state.Place_ku,
      NOoFProperty: this.state.NOoFProperty,
      Property: this.state.Property,
      Area: this.state.Area,
      MonthForRent: parseFloat(
        this.state.MonthForRent.toString().replace(/,/g, "")
      ),
      Monthintroduction:
        this.state.Monthintroduction &&
        parseFloat(this.state.Monthintroduction.toString().replace(/,/g, "")),
      note: this.state.note,
      block: this.state.block,
      flour: this.state.flour,
      metrPrice: this.state.metrPrice,
      witness1: this.state.witness1,
      witness2: this.state.witness2,
      status: this.state.status,
      createdAt: this.state.createdAt,
    };
    if (
      this.state.firstname === "" ||
      this.state.secondname === "" ||
      this.state.paymentmonth === "" ||
      this.state.paymentmonth === 0 ||
      this.state.currency.toString().length === 0 ||
      this.state.rental === "" ||
      this.state.Property.toString().length === 0
    ) {
      Swal.fire({
        title: "OPS",
        text: this.props.change_Lang("Please Check Inputs"),
        icon: "error",
        html: `<b class="fk">${this.props.change_Lang(
          "Please Check Inputs"
        )}</b>`,
        confirmButtonText: this.props.change_Lang("Ok"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${change_Lang(
          "You successfully tainted your work"
        )}</b>`,
        icon: "success",
        confirmButtonText: change_Lang("success"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      Update_RentContract(rent_all_view_obj._id, data);
      setTimeout(() => {
        Get_List_All_Rent_Contracts();
      }, 2000);
      onClose();
      this.setState({ update_open: false, update_close: true });
    }
  };
  OnChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleChange_Property = (value) => {
    this.setState({ Property: value });
  };
  handleChange_Status = (value) => {
    this.setState({ status: value });
  };
  render() {
    const {
      update_close,
      update_open,
      flour,
      block,
      note,
      MonthForRent,
      Monthintroduction,
      Area,
      Property,
      NOoFProperty,
      Place_ku,
      currency,
      safly,
      perpose,
      rental,
      feelate,
      enddate,
      startdate,
      paymentmonth,
      duedate,
      secondname,
      firstname,
      introduction,
      phone1,
      phone2,
      status,
      createdAt,
      witness1,
      witness2,
    } = this.state;
    const {
      lang,
      change_Lang,
      rent_all_view_obj,
      index_all_rent,
      name_arb,
      name_en,
      name_krd,
    } = this.props;
    const {
      onOpenUpdate,
      onCloseUpdate,
      OnChangeHandler,
      handleChange_Status,
    } = this;
    const { Option } = Select;
    return (
      <>
        <div className={`${lang === "en" ? "" : " fk"}`}>
          <div className="row">
            <div className="col-12">
              <div className="row p-3">
                <div className="col-md-6 text-right ">
                  <p
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    className=" d-flex justify-content-start"
                  >
                    {change_Lang("Company Branch")}: &nbsp;
                    {rent_all_view_obj.branchId
                      ? rent_all_view_obj.branchId.name
                      : ""}
                  </p>
                  <p
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    className=" d-flex justify-content-start"
                  >
                    {change_Lang("Currency Type")}: &nbsp;
                    {change_Lang(currency)}
                  </p>
                </div>

                <div className="col-md-6">
                  <p
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    className=""
                  >
                    {change_Lang("contract number")} {index_all_rent} #
                  </p>
                  <p
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    className=""
                  >
                    {change_Lang("date")} &nbsp;
                    {update_open !== true ? (
                      <Time
                        value={rent_all_view_obj.createdAt}
                        format="YYYY-MM-DD"
                        style={{ color: "black" }}
                      />
                    ) : (
                      <label>
                        <input
                          type="date"
                          value={createdAt}
                          name="createdAt"
                          onChange={OnChangeHandler}
                          autoComplete="off"
                          className="form-control fk text-center"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#3889c1",
                          }}
                        />
                      </label>
                    )}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p
                    style={{
                      fontSize: "20px",
                      color: "black",
                      background: "#e3e9f2",
                    }}
                    className="mb-4 d-flex justify-content-center text-uppercase p-1"
                  >
                    {change_Lang("Rental contract")}
                  </p>
                  {/* Names */}
                  <div className="form-group row form-inline">
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {change_Lang("First Side")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          firstname
                        ) : (
                          <input
                            type="text"
                            value={firstname}
                            name="firstname"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {" "}
                      {change_Lang("Second Side")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          secondname
                        ) : (
                          <input
                            type="text"
                            value={secondname}
                            name="secondname"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                  </div>
                  {/* phone */}
                  <div className="form-group row form-inline">
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {change_Lang("phone_number")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          phone1
                        ) : (
                          <input
                            type="text"
                            value={phone1}
                            name="phone1"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {" "}
                      {change_Lang("phone_number")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          phone2
                        ) : (
                          <input
                            type="text"
                            value={phone2}
                            name="phone2"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                  </div>
                  {/* witness */}
                  {/* <div className="form-group row form-inline">
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {change_Lang("Witness")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          witness1
                        ) : (
                          <input
                            type="text"
                            value={witness1}
                            name="witness1"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {" "}
                      {change_Lang("Witness")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          witness2
                        ) : (
                          <input
                            type="text"
                            value={witness2}
                            name="witness2"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                  </div> */}
                  {/* second */}
                  <div className="form-group row form-inline">
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {change_Lang("first_rule_Property_type")}:
                    </label>
                    <div className="col-sm-3">
                      <label>
                        {update_open !== true ? (
                          change_Lang(Property)
                        ) : (
                          <PropertyesList
                            onChangeProperty={this.handleChange_Property}
                            valueOption={Property}
                            className="fk text-center"
                            showSearch
                            optionFilterProp="children"
                            filterOption={true}
                            showArrow={false}
                            size="large"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#ed3537",
                              width: "196px",
                            }}
                          />
                        )}
                      </label>
                    </div>
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {" "}
                      {change_Lang("first_rule_place")}:
                    </label>
                    <div className="col-sm-3">
                      <label>
                        {update_open !== true ? (
                          Place_ku
                        ) : (
                          <input
                            type="text"
                            value={Place_ku}
                            name="Place_ku"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                  </div>
                  {/* Thisrd */}
                  <div className="form-group row form-inline">
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {change_Lang("Area")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          Area
                        ) : (
                          <input
                            type="text"
                            value={Area}
                            name="Area"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {change_Lang("Number")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          NOoFProperty
                        ) : (
                          <input
                            type="text"
                            value={NOoFProperty}
                            name="NOoFProperty"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            className="form-control fk text-center"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#3889c1",
                            }}
                          />
                        )}
                      </label>
                    </div>
                  </div>
                  {/* forth */}
                  {Property === "Apartment" ? (
                    <>
                      <div className="form-group row form-inline">
                        <label
                          style={{ fontSize: "16px", color: "black" }}
                          className="col-sm-2 col-form-label"
                        >
                          {change_Lang("block")}:
                        </label>
                        <div className="col-sm-3">
                          <label className="">
                            {update_open !== true ? (
                              block
                            ) : (
                              <input
                                type="text"
                                value={block}
                                name="block"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            )}
                          </label>
                        </div>
                        <label
                          style={{ fontSize: "16px", color: "black" }}
                          className="col-sm-2 col-form-label"
                        >
                          {" "}
                          {change_Lang("flour")}:
                        </label>
                        <div className="col-sm-3">
                          <label className="">
                            {update_open !== true ? (
                              flour
                            ) : (
                              <input
                                type="text"
                                value={flour}
                                name="flour"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            )}
                          </label>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {/* </div> */}
                  <div className="form-group row form-inline">
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {change_Lang("type of contract")}:
                    </label>
                    <div className="col-sm-3">
                      <label className="">
                        {update_open !== true ? (
                          change_Lang(status)
                        ) : (
                          <Select
                            onChange={handleChange_Status}
                            value={status}
                            defaultValue={change_Lang("Choose")}
                            size="large"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#000000",
                              width: "196px",
                            }}
                            className="fk text-center"
                          >
                            <Option value="" className="fk">
                              {change_Lang("Choose")}
                            </Option>
                            <Option className="fk" value={"active"}>
                              {change_Lang("active")}
                            </Option>
                            <Option className="fk" value={"Rejected"}>
                              {change_Lang("Rejected")}
                            </Option>
                          </Select>
                        )}
                      </label>
                    </div>
                    <label
                      style={{ fontSize: "16px", color: "black" }}
                      className="col-sm-2 col-form-label"
                    >
                      {" "}
                    </label>
                    <div className="col-sm-3">
                      <label className=""></label>
                    </div>
                  </div>
                  <br />
                  <hr />
                  <p
                    style={{ fontSize: "18px", color: "black" }}
                    className="mb-1 d-flex justify-content-center"
                  >
                    {change_Lang("agreement")}
                  </p>
                </div>
              </div>
              <div className="row ">
                <div className="col-md-12">
                  <table className="table">
                    <tbody>
                      <tr style={{ background: "#e3e9f2" }}>
                        <td>1</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("balav_1_1")}
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("balav_2_1")}
                          &nbsp;&nbsp; (
                          <label className="">
                            {update_open !== true ? (
                              rental
                            ) : (
                              <input
                                type="text"
                                value={rental}
                                name="rental"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            )}
                          </label>
                          ) &nbsp;&nbsp;
                          {change_Lang("balav_2_2")}
                          &nbsp;
                          <label>
                            {update_open !== true ? (
                              <Time
                                value={startdate}
                                format="YYYY-MM-DD"
                                style={{
                                  color: "black",
                                  fontWeight: "normal",
                                }}
                              />
                            ) : (
                              <input
                                type="date"
                                value={startdate}
                                name="startdate"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            )}
                          </label>
                          &nbsp;
                          {change_Lang("balav_2_3")}&nbsp;
                          <label className="">
                            {update_open !== true ? (
                              <Time
                                value={enddate}
                                format="YYYY-MM-DD"
                                style={{
                                  color: "black",
                                  fontWeight: "normal",
                                }}
                              />
                            ) : (
                              <input
                                type="date"
                                value={enddate}
                                name="enddate"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            )}
                          </label>
                          &nbsp;
                          {change_Lang("balav_2_4")}
                        </td>
                      </tr>
                      <tr style={{ background: "#e3e9f2" }}>
                        <td>3</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("balav_3_1")}&nbsp;
                          <NumberFormat
                            displayType={`${
                              update_open !== true ? "text" : "input"
                            }`}
                            thousandSeparator={true}
                            value={paymentmonth}
                            name="paymentmonth"
                            onChange={OnChangeHandler}
                            className="text-center"
                            prefix={`${update_open !== true ? "$" : ""}`}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("Rent_agreement")}
                          &nbsp;(
                          <NumberFormat
                            displayType={`${
                              update_open !== true ? "text" : "input"
                            }`}
                            thousandSeparator={true}
                            value={MonthForRent}
                            name="MonthForRent"
                            onChange={OnChangeHandler}
                            className="text-center"
                          />
                          )&nbsp;
                          {change_Lang("once a preludant")}.
                        </td>
                      </tr>
                      <tr style={{ background: "#e3e9f2" }}>
                        <td>5</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("balav_4_1")}&nbsp;
                          <NumberFormat
                            displayType={`${
                              update_open !== true ? "text" : "input"
                            }`}
                            thousandSeparator={true}
                            value={introduction}
                            name="introduction"
                            onChange={OnChangeHandler}
                            required
                            className="text-center"
                            prefix={`${update_open !== true ? "$" : ""}`}
                          />
                          &nbsp;
                          {change_Lang("balav_4_2")}
                          &nbsp; (
                          <NumberFormat
                            displayType={`${
                              update_open !== true ? "text" : "input"
                            }`}
                            thousandSeparator={true}
                            value={Monthintroduction}
                            name="Monthintroduction"
                            className="text-center"
                            onChange={OnChangeHandler}
                          />
                          ) &nbsp;
                          {change_Lang("month")}
                        </td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("balav_6_1")}&nbsp;
                          <NumberFormat
                            displayType={`${
                              update_open !== true ? "text" : "input"
                            }`}
                            thousandSeparator={true}
                            style={{ fontWeight: "bold" }}
                            value={safly}
                            name="safly"
                            onChange={OnChangeHandler}
                            className="text-center"
                            prefix={`${update_open !== true ? "$" : ""}`}
                          />
                          &nbsp;
                          {lang === "krd"
                            ? `وەك دلنيايى(تأمینات) بە ${name_krd} وه پێویستە لەسەر کرێچی کە پسولەی ئەسلی پێبێت بۆ داناوەی تەئمینات به مەرجيك لايەنى دووەم مۆڵكەكه بەبى بوونى هيج كەم و كوڕيەك رادەست بكاتەوه بە پێچەوانەوە پارە کە نادرێتەوە لایەنی دووەم .`
                            : lang === "arb"
                            ? `كتأمينات إلى ${name_arb} وفق ورقة الإيصال المرقمة`
                            : `as insurance to ${name_en} as per the invoice number`}
                        </td>
                      </tr>
                      <tr style={{ background: "#e3e9f2" }}>
                        <td>7</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("balav_7_1")}&nbsp;
                          <label className="">
                            {update_open !== true ? (
                              Property !== "House" &&
                              Property !== "Apartment" ? (
                                perpose
                              ) : (
                                change_Lang(perpose)
                              )
                            ) : Property !== "House" &&
                              Property !== "Apartment" ? (
                              <input
                                type="text"
                                value={perpose}
                                name="perpose"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            ) : (
                              <select
                                value={perpose}
                                onChange={OnChangeHandler}
                                name="perpose"
                                className="form-control text-center fk"
                                required
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                <option
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                  }}
                                  value=""
                                >
                                  --{change_Lang("Choose")}--
                                </option>
                                <option
                                  value={"Housing"}
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                  }}
                                >
                                  {change_Lang("Housing")}
                                </option>
                                <option
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                  }}
                                  value={"office"}
                                >
                                  {change_Lang("office")}
                                </option>
                              </select>
                            )}
                          </label>
                          &nbsp;
                          {lang === "krd"
                            ? `له كاتى بەكارهێنانى بۆ هەر مەبەستێكى تر پێويستە ئاگادارى ${name_krd} بكات و رەزامەندى لايەنى يەكەم به نوسراوو وەربگريت.به پێجەوانەوە مافى لايەنى يەكەمه ئەم گريبەستە هەڵبوشێنێتەوە بەبى ئاگادار كردنەوەى لايەنى دووەم",`
                            : lang === "arb"
                            ? `وعند استخدامه لأي غرض آخر يجب تبيلغ ${name_arb} عن ذلك وبموافقة خطية من الطرف الأول. خلافاً لذلك يحق للطرف الأول إبطال العقد دون تبيلغ الطرف الثاني.`
                            : `and when using it for any other purpose it should notify ${name_en} and to get a written agreement from the first party, otherwise the first party has the right to terminate this contract without notifying the second party.`}
                        </td>
                      </tr>
                      <DynamicArticle_FirstPart
                        bg_color={"#e3e9f2"}
                        styles={{
                          lineHeight: "1.8",
                          wordSpacing: "5px",
                          fontWeight: "bold",
                        }}
                      />
                      <tr>
                        <td>12</td>
                        <td
                          style={{
                            lineHeight: "1.8",
                            wordSpacing: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          {change_Lang("balav_19_1")}
                          &nbsp;
                          <NumberFormat
                            displayType={`${
                              update_open !== true ? "text" : "input"
                            }`}
                            thousandSeparator={true}
                            value={feelate}
                            name="feelate"
                            onChange={OnChangeHandler}
                            className="text-center"
                            prefix={`${update_open !== true ? "$" : ""}`}
                          />
                          &nbsp; {change_Lang("balav_19_2")}
                        </td>
                      </tr>
                      <DynamicArticle
                        bg_color={"#e3e9f2"}
                        styles={{
                          lineHeight: "1.8",
                          wordSpacing: "5px",
                          fontWeight: "bold",
                        }}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
              <hr />
              <br />
              <div className="form-inline">
                <label
                  style={{
                    fontSize: "18px",
                    fontWeight: "bolder",
                    color: "black",
                  }}
                  className="form-label d-flex justify-content-start"
                >
                  {change_Lang("note")}&nbsp;:
                </label>
                &nbsp;&nbsp;
                <label
                  style={{
                    fontSize: "16px",
                    color: "black",
                    fontWeight: "bold",
                    wordSpacing: "4px",
                  }}
                  className="form-label d-flex justify-content-start"
                >
                  {note}
                </label>
              </div>
              {/* Footer */}
              <div className="row">
                <div className="form-group d-flex justify-content-center col-md-6">
                  <label
                    style={{
                      fontSize: "18px",
                      fontWeight: "bolder",
                      color: "black",
                      alignItems: "center",
                    }}
                    className="form-label"
                  >
                    {change_Lang("First side (property owner)")}
                  </label>
                </div>
                <div className="col-md-6 d-flex justify-content-center">
                  <div className="form-group ">
                    <label
                      style={{
                        fontSize: "18px",
                        color: "black",
                        alignItems: "center",
                      }}
                      className="form-label"
                    >
                      {change_Lang("Second side (tenant)")}
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group d-flex justify-content-center">
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                      alignItems: "center",
                    }}
                    className="form-label"
                  >
                    {firstname}
                  </label>
                </div>
                <div className="col-md-6 d-flex justify-content-center">
                  <div className="form-group ">
                    <label
                      style={{
                        fontSize: "18px",
                        color: "black",
                        alignItems: "center",
                      }}
                      className="form-label"
                    >
                      {secondname}
                    </label>
                  </div>
                </div>
              </div>
              <br />
              {/* Footer */}
              <div className="row">
                <div className="form-group d-flex justify-content-center col-md-12">
                  <label
                    style={{
                      fontSize: "18px",
                      fontWeight: "bolder",
                      color: "black",
                      alignItems: "center",
                    }}
                    className="form-label"
                  >
                    {lang === "krd"
                      ? `( ب- ${name_krd} )`
                      : lang === "arb"
                      ? `منظم العقد/ ${name_arb}`
                      : `Contract organizer /${name_en}`}
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <div className="form-group d-flex justify-content-center">
                    <label
                      style={{
                        fontSize: "18px",
                        color: "black",
                        alignItems: "center",
                      }}
                      className="form-label"
                    >
                      {`${
                        rent_all_view_obj.agentId
                          ? rent_all_view_obj.agentId.fname
                          : ""
                      } ${
                        rent_all_view_obj.agentId
                          ? rent_all_view_obj.agentId.lname
                          : ""
                      }`}
                    </label>
                    <div></div>
                  </div>
                </div>
                <div className="col-md-4"></div>
              </div>
              <div
                className="d-flex flex-row-reverse  text-white p-4"
                style={{ background: "#e3e9f2" }}
              >
                <div className="py-3 px-5 text-right">
                  {update_close !== false ? (
                    <button onClick={onOpenUpdate} className="btn btn-primary">
                      {change_Lang("profile_updatebt")}&nbsp;&nbsp;
                      <i
                        style={{ fontSize: "18px" }}
                        className="fa fa-lock"
                      ></i>
                    </button>
                  ) : (
                    <button onClick={onCloseUpdate} className="btn btn-primary">
                      {change_Lang("profile_updatebt")}&nbsp;&nbsp;
                      <i
                        style={{ fontSize: "18px" }}
                        className="fa fa-lock-open"
                      ></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ViewAllRent;
